import styled from 'styled-components';
import {colors} from '../../../utils/styled/_variables.styled';

export const InfiosLabel = styled.label`
    display: flex;
    margin: 16px 0 8px;
    color: ${props => props.disabled ? colors.gray4 : colors.infiosGray};

    &:after {
        content: '*';
        display: ${props => props.required ? 'inline' : 'none'};
        margin-left: 6px;
    }

    a {
        position: relative;
        z-index: 2;
    }
`
